"use strict";

/* ============================================================
ASOCIACIÓN SOLIDARISTA

Archivo:
src/fronend/Egresos/solidarista/solidarista.js

FUNCIONES:

* Listar empleados
* Seleccionar empleado
* Llenar datos automáticamente
* Registrar ahorro solidarista
* Editar registro
* Calcular descuento
* Eliminar registro
* Buscar registros

============================================================ */

/* ============================================================
VARIABLES
============================================================ */

let registrosSolidarista = [];

let empleadosSolidarista = [];

let modalNuevoSolidarista = null;

let modalEditarSolidarista = null;

/* ============================================================
RUTAS
============================================================ */

const API_SOLIDARISTA = {


listar: "/asociacion/listar",

empleados: "/asociacion/listarEmpleadosSolis",

guardar: "/asociacion/guardar",

actualizar: "/asociacion/actualizar",

eliminar: "/asociacion/eliminar"


};

/* ============================================================
INICIO
============================================================ */

document.addEventListener(


"DOMContentLoaded",

async () => {

    try {

        inicializarModales();

        inicializarEventos();

        establecerFechaActual();

        await cargarEmpleadosSolidarista();

        await cargarRegistrosSolidarista();

    } catch (error) {

        console.error(
            "Error al inicializar Asociación Solidarista:",
            error
        );

    }

}


);

/* ============================================================
INICIALIZAR MODALES
============================================================ */

function inicializarModales() {


const elementoNuevo =
    document.getElementById(
        "modalSolidarista"
    );

const elementoEditar =
    document.getElementById(
        "modalEditarSolidarista"
    );


if (elementoNuevo) {

    modalNuevoSolidarista =
        new bootstrap.Modal(
            elementoNuevo
        );

}


if (elementoEditar) {

    modalEditarSolidarista =
        new bootstrap.Modal(
            elementoEditar
        );

}


}

/* ============================================================
EVENTOS
============================================================ */

function inicializarEventos() {


/* --------------------------------------------------------
   BOTÓN NUEVO
-------------------------------------------------------- */

const btnNuevo =
    document.getElementById(
        "btnNuevoSolidarista"
    );


if (btnNuevo) {

    btnNuevo.addEventListener(

        "click",

        async () => {

            limpiarFormularioNuevo();

            establecerFechaActual();

            await cargarEmpleadosSolidarista();

            if (modalNuevoSolidarista) {

                modalNuevoSolidarista.show();

            }

        }

    );

}


/* --------------------------------------------------------
   SELECT EMPLEADO
-------------------------------------------------------- */

const selectEmpleado =
    document.getElementById(
        "idEmpleadoSolidarista"
    );


if (selectEmpleado) {

    selectEmpleado.addEventListener(
        "change",
        seleccionarEmpleadoSolidarista
    );

}


/* --------------------------------------------------------
   AHORRO NUEVO
-------------------------------------------------------- */

const ahorroNuevo =
    document.getElementById(
        "ahorroSolidarista"
    );


if (ahorroNuevo) {

    ahorroNuevo.addEventListener(
        "input",
        calcularDescuentoNuevo
    );

}


/* --------------------------------------------------------
   AHORRO EDITAR
-------------------------------------------------------- */

const ahorroEditar =
    document.getElementById(
        "editarAhorroSolidarista"
    );


if (ahorroEditar) {

    ahorroEditar.addEventListener(
        "input",
        calcularDescuentoEditar
    );

}


/* --------------------------------------------------------
   FORMULARIO NUEVO
-------------------------------------------------------- */

const formularioNuevo =
    document.getElementById(
        "formSolidarista"
    );


if (formularioNuevo) {

    formularioNuevo.addEventListener(
        "submit",
        guardarSolidarista
    );

}


/* --------------------------------------------------------
   FORMULARIO EDITAR
-------------------------------------------------------- */

const formularioEditar =
    document.getElementById(
        "formEditarSolidarista"
    );


if (formularioEditar) {

    formularioEditar.addEventListener(
        "submit",
        actualizarSolidarista
    );

}


/* --------------------------------------------------------
   BUSCAR
-------------------------------------------------------- */

const buscar =
    document.getElementById(
        "buscarSolidarista"
    );


if (buscar) {

    buscar.addEventListener(
        "input",
        filtrarTablaSolidarista
    );

}


/* --------------------------------------------------------
   LIMPIAR BÚSQUEDA
-------------------------------------------------------- */

const limpiarBusqueda =
    document.getElementById(
        "btnLimpiarBusqueda"
    );


if (limpiarBusqueda) {

    limpiarBusqueda.addEventListener(

        "click",

        () => {

            if (buscar) {

                buscar.value = "";

            }

            renderizarTablaSolidarista(
                registrosSolidarista
            );

        }

    );

}


/* --------------------------------------------------------
   ACCIONES TABLA
-------------------------------------------------------- */

const tbody =
    document.getElementById(
        "tbodySolidarista"
    );


if (tbody) {

    tbody.addEventListener(
        "click",
        manejarAccionesTabla
    );

}


}

/* ============================================================
CARGAR EMPLEADOS
============================================================ */

async function cargarEmpleadosSolidarista() {

const select =
    document.getElementById(
        "idEmpleadoSolidarista"
    );


if (!select) {

    return;

}


try {

    select.innerHTML = `
        <option value="">
            Cargando empleados...
        </option>
    `;


    const respuesta =
        await fetchJSON(
            API_SOLIDARISTA.empleados
        );


    empleadosSolidarista =
        normalizarLista(
            respuesta.empleados ||
            respuesta.data ||
            respuesta
        );


    select.innerHTML = `
        <option value="">
            Seleccione un empleado
        </option>
    `;


    if (
        !Array.isArray(
            empleadosSolidarista
        ) ||
        empleadosSolidarista.length === 0
    ) {

        select.innerHTML = `
            <option value="">
                No hay empleados disponibles
            </option>
        `;

        return;

    }


    empleadosSolidarista.forEach(
        empleado => {

            const id =
                obtenerValor(
                    empleado,
                    [
                        "IDEMPLEADO",
                        "idEmpleado",
                        "IdEmpleado",
                        "id"
                    ]
                );


            const nombre =
                obtenerValor(
                    empleado,
                    [
                        "NOMBREEMPLEADO",
                        "nombreEmpleado",
                        "NOMBRE",
                        "nombre"
                    ]
                );


            if (
                id === null ||
                id === undefined
            ) {

                return;

            }


            const option =
                document.createElement(
                    "option"
                );


            option.value = id;

            option.textContent =
                `${id} - ${nombre || ""}`;


            select.appendChild(
                option
            );

        }
    );


} catch (error) {

    console.error(
        "Error cargando empleados:",
        error
    );


    select.innerHTML = `
        <option value="">
            Error al cargar empleados
        </option>
    `;

}


}

/* ============================================================
SELECCIONAR EMPLEADO
============================================================ */

function seleccionarEmpleadoSolidarista() {


const select =
    document.getElementById(
        "idEmpleadoSolidarista"
    );


if (!select) {

    return;

}


const idSeleccionado =
    select.value;


if (!idSeleccionado) {

    limpiarDatosEmpleadoNuevo();

    return;

}


const empleado =
    empleadosSolidarista.find(
        item => {

            const id =
                obtenerValor(
                    item,
                    [
                        "IDEMPLEADO",
                        "idEmpleado",
                        "IdEmpleado",
                        "id"
                    ]
                );


            return String(id) ===
                String(idSeleccionado);

        }
    );


if (!empleado) {

    console.warn(
        "No se encontró el empleado:",
        idSeleccionado
    );

    return;

}


llenarDatosEmpleadoNuevo(
    empleado
);


}

/* ============================================================
LLENAR DATOS EMPLEADO - NUEVO
============================================================ */

function llenarDatosEmpleadoNuevo(
empleado
) {

const id =
    obtenerValor(
        empleado,
        [
            "IDEMPLEADO",
            "idEmpleado",
            "IdEmpleado",
            "id"
        ]
    );


const nombre =
    obtenerValor(
        empleado,
        [
            "NOMBREEMPLEADO",
            "nombreEmpleado",
            "NOMBRE",
            "nombre"
        ]
    );


const dpi =
    obtenerValor(
        empleado,
        [
            "DPI",
            "dpi"
        ]
    );


const puesto =
    obtenerValor(
        empleado,
        [
            "NOMBREPUESTO",
            "nombrePuesto",
            "PUESTO",
            "puesto"
        ]
    );


const direccion =
    obtenerValor(
        empleado,
        [
            "DIRECCION",
            "direccion"
        ]
    );


const salario =
    obtenerValor(
        empleado,
        [
            "SALARIOBASE",
            "salarioBase",
            "SALARIO",
            "salario",
            "SUELDO",
            "sueldo"
        ]
    );


establecerValor(
    "mostrarIdEmpleadoSolidarista",
    id
);


establecerValor(
    "nombreEmpleadoSolidarista",
    nombre
);


establecerValor(
    "dpiEmpleadoSolidarista",
    dpi
);


establecerValor(
    "puestoEmpleadoSolidarista",
    puesto
);


establecerValor(
    "direccionEmpleadoSolidarista",
    direccion
);


establecerValor(
    "salarioBaseSolidarista",
    numero(salario).toFixed(2)
);


calcularDescuentoNuevo();


}

/* ============================================================
CARGAR REGISTROS
============================================================ */

async function cargarRegistrosSolidarista() {


const tbody =
    document.getElementById(
        "tbodySolidarista"
    );


if (!tbody) {

    return;

}


try {

    mostrarCargandoTabla();


    const respuesta =
        await fetchJSON(
            API_SOLIDARISTA.listar
        );


    registrosSolidarista =
        normalizarLista(
            respuesta.data ||
            respuesta.registros ||
            respuesta.bancos ||
            respuesta
        );


    renderizarTablaSolidarista(
        registrosSolidarista
    );


    actualizarResumen();


} catch (error) {

    console.error(
        "Error cargando registros:",
        error
    );


    tbody.innerHTML = `
        <tr>
            <td
                colspan="12"
                class="empty-state">

                <i class="bi bi-exclamation-triangle d-block"></i>

                Error al cargar los registros.

                <br>

                <small>
                    ${escaparHTML(error.message)}
                </small>

            </td>
        </tr>
    `;

}


}

/* ============================================================
RENDERIZAR TABLA
============================================================ */

function renderizarTablaSolidarista(
registros
) {


const tbody =
    document.getElementById(
        "tbodySolidarista"
    );


if (!tbody) {

    return;

}


tbody.innerHTML = "";


if (
    !Array.isArray(registros) ||
    registros.length === 0
) {

    tbody.innerHTML = `
        <tr>
            <td
                colspan="12"
                class="empty-state">

                <i class="bi bi-piggy-bank d-block"></i>

                No existen registros de
                Asociación Solidarista.

            </td>
        </tr>
    `;


    actualizarResumen();

    return;

}


registros.forEach(
    (registro, indice) => {

        const id =
            obtenerValor(
                registro,
                [
                    "IDBANCOS",
                    "idBancos",
                    "ID"
                ]
            );


        const fecha =
            obtenerValor(
                registro,
                [
                    "FECHA",
                    "FECHAREGISTRO",
                    "fecha"
                ]
            );


        const idEmpleado =
            obtenerValor(
                registro,
                [
                    "IDEMPLEADO",
                    "idEmpleado"
                ]
            );


        const nombre =
            obtenerValor(
                registro,
                [
                    "NOMBREEMPLEADO",
                    "nombreEmpleado",
                    "NOMBRE"
                ]
            ) || "Sin nombre";


        const dpi =
            obtenerValor(
                registro,
                [
                    "DPI",
                    "dpi"
                ]
            ) || "";


        const puesto =
            obtenerValor(
                registro,
                [
                    "NOMBREPUESTO",
                    "PUESTO",
                    "nombrePuesto"
                ]
            ) || "";


        const direccion =
            obtenerValor(
                registro,
                [
                    "DIRECCION",
                    "direccion"
                ]
            ) || "";


        const banco =
            obtenerValor(
                registro,
                [
                    "NOMBREBANCO",
                    "nombreBanco"
                ]
            ) || "";


        const salario =
            numero(
                obtenerValor(
                    registro,
                    [
                        "SALARIOBASE",
                        "salarioBase",
                        "SALARIO"
                    ]
                )
            );


        const ahorro =
            numero(
                obtenerValor(
                    registro,
                    [
                        "AHORRO",
                        "ahorro",
                        "INGRESODEDINEROAHORRO"
                    ]
                )
            );


        const descuento =
            numero(
                obtenerValor(
                    registro,
                    [
                        "DESCUENTO",
                        "descuento",
                        "IDDESCUENTO"
                    ]
                )
            );


        const estado =
            obtenerValor(
                registro,
                [
                    "ESTADO",
                    "estado"
                ]
            ) || "I";


        const inicial =
            nombre
                .trim()
                .charAt(0)
                .toUpperCase();


        const fila =
            document.createElement(
                "tr"
            );


        fila.innerHTML = `
            <td>
                ${indice + 1}
            </td>

            <td>
                ${formatearFecha(fecha)}
            </td>

            <td>
                <div class="d-flex align-items-center">

                    <div class="employee-avatar">
                        ${escaparHTML(inicial)}
                    </div>

                    <div>

                        <div class="employee-name">
                            ${escaparHTML(nombre)}
                        </div>

                        <small class="text-muted">
                            ID:
                            ${escaparHTML(
                                String(
                                    idEmpleado || ""
                                )
                            )}
                        </small>

                    </div>

                </div>
            </td>

            <td>
                ${escaparHTML(String(dpi))}
            </td>

            <td>
                ${escaparHTML(String(puesto))}
            </td>

            <td>
                ${escaparHTML(String(direccion))}
            </td>

            <td>
                ${escaparHTML(String(banco))}
            </td>

            <td class="salary">
                Q ${formatearNumero(salario)}
            </td>

            <td class="ahorro">
                Q ${formatearNumero(ahorro)}
            </td>

            <td class="descuento">
                Q ${formatearNumero(descuento)}
            </td>

            <td>

                ${
                    String(estado)
                        .toUpperCase() === "A"

                    ?

                    `
                        <span class="badge-activo">
                            Activo
                        </span>
                    `

                    :

                    `
                        <span class="badge-inactivo">
                            Inactivo
                        </span>
                    `
                }

            </td>

            <td>

                <div class="d-flex gap-2">

                    <button
                        type="button"
                        class="btn-accion btn-editar-solidarista"
                        data-accion="editar"
                        data-id="${escaparHTML(
                            String(id)
                        )}"
                        title="Editar">

                        <i class="bi bi-pencil-square"></i>

                    </button>


                    <button
                        type="button"
                        class="btn-accion btn-eliminar-solidarista"
                        data-accion="eliminar"
                        data-id="${escaparHTML(
                            String(id)
                        )}"
                        title="Eliminar">

                        <i class="bi bi-trash-fill"></i>

                    </button>

                </div>

            </td>
        `;


        tbody.appendChild(
            fila
        );

    }
);


actualizarResumen();


}

/* ============================================================
ABRIR MODAL EDITAR
============================================================ */

function abrirModalEditar(
id
) {


console.log(
    "ID seleccionado para editar:",
    id
);


const registro =
    registrosSolidarista.find(
        item => {

            const idRegistro =
                obtenerValor(
                    item,
                    [
                        "IDBANCOS",
                        "idBancos",
                        "ID"
                    ]
                );


            return String(idRegistro) ===
                String(id);

        }
    );


if (!registro) {

    console.error(
        "No se encontró el registro:",
        id
    );


    alert(
        "No se encontró el registro seleccionado."
    );

    return;

}


console.log(
    "REGISTRO COMPLETO:",
    registro
);


const idBancos =
    obtenerValor(
        registro,
        [
            "IDBANCOS",
            "idBancos",
            "ID"
        ]
    );


const idEmpleado =
    obtenerValor(
        registro,
        [
            "IDEMPLEADO",
            "idEmpleado",
            "IdEmpleado"
        ]
    );


const nombre =
    obtenerValor(
        registro,
        [
            "NOMBREEMPLEADO",
            "nombreEmpleado",
            "NOMBRE",
            "nombre"
        ]
    );


const dpi =
    obtenerValor(
        registro,
        [
            "DPI",
            "dpi"
        ]
    );


const puesto =
    obtenerValor(
        registro,
        [
            "NOMBREPUESTO",
            "nombrePuesto",
            "PUESTO",
            "puesto"
        ]
    );


const direccion =
    obtenerValor(
        registro,
        [
            "DIRECCION",
            "direccion"
        ]
    );


const banco =
    obtenerValor(
        registro,
        [
            "NOMBREBANCO",
            "nombreBanco"
        ]
    );


const salario =
    obtenerValor(
        registro,
        [
            "SALARIOBASE",
            "salarioBase",
            "SALARIO",
            "salario"
        ]
    );


const ahorro =
    obtenerValor(
        registro,
        [
            "AHORRO",
            "ahorro",
            "INGRESODEDINEROAHORRO"
        ]
    );


const fecha =
    obtenerValor(
        registro,
        [
            "FECHA",
            "FECHAREGISTRO",
            "fecha"
        ]
    );


const estado =
    obtenerValor(
        registro,
        [
            "ESTADO",
            "estado"
        ]
    ) || "A";


establecerValor(
    "editarIdBancosSolidarista",
    idBancos
);


establecerValor(
    "editarIdEmpleadoSolidarista",
    idEmpleado
);


establecerValor(
    "editarNombreEmpleadoSolidarista",
    nombre
);


establecerValor(
    "editarDpiEmpleadoSolidarista",
    dpi
);


establecerValor(
    "editarPuestoEmpleadoSolidarista",
    puesto
);


establecerValor(
    "editarDireccionEmpleadoSolidarista",
    direccion
);


establecerValor(
    "editarNombreBancoSolidarista",
    banco
);


establecerValor(
    "editarSalarioBaseSolidarista",
    numero(salario).toFixed(2)
);


establecerValor(
    "editarAhorroSolidarista",
    numero(ahorro).toFixed(2)
);


calcularDescuentoEditar();


establecerValor(
    "editarFechaSolidarista",
    convertirFechaInput(fecha)
);


establecerValor(
    "editarEstadoSolidarista",
    estado
);


if (modalEditarSolidarista) {

    modalEditarSolidarista.show();

} else {

    const elemento =
        document.getElementById(
            "modalEditarSolidarista"
        );


    if (elemento) {

        modalEditarSolidarista =
            new bootstrap.Modal(
                elemento
            );


        modalEditarSolidarista.show();

    }

}


}

/* ============================================================
MANEJAR BOTONES TABLA
============================================================ */

function manejarAccionesTabla(
evento
) {


const boton =
    evento.target.closest(
        "button[data-accion]"
    );


if (!boton) {

    return;

}


const accion =
    boton.dataset.accion;


const id =
    boton.dataset.id;


if (accion === "editar") {

    abrirModalEditar(id);

}


if (accion === "eliminar") {

    eliminarSolidarista(id);

}


}

/* ============================================================
CALCULAR DESCUENTO NUEVO
============================================================ */

function calcularDescuentoNuevo() {


const salario =
    numero(
        document.getElementById(
            "salarioBaseSolidarista"
        )?.value
    );


const ahorro =
    numero(
        document.getElementById(
            "ahorroSolidarista"
        )?.value
    );


let descuento =
    salario - ahorro;


if (descuento < 0) {

    descuento = 0;

}


const input =
    document.getElementById(
        "descuentoSolidarista"
    );


if (input) {

    input.value =
        descuento.toFixed(2);

}

}

/* ============================================================
CALCULAR DESCUENTO EDITAR
============================================================ */

function calcularDescuentoEditar() {


const salario =
    numero(
        document.getElementById(
            "editarSalarioBaseSolidarista"
        )?.value
    );


const ahorro =
    numero(
        document.getElementById(
            "editarAhorroSolidarista"
        )?.value
    );


let descuento =
    salario - ahorro;


if (descuento < 0) {

    descuento = 0;

}


const input =
    document.getElementById(
        "editarDescuentoSolidarista"
    );


if (input) {

    input.value =
        descuento.toFixed(2);

}


}

/* ============================================================
GUARDAR
============================================================ */

async function guardarSolidarista(
evento
) {


evento.preventDefault();


const idEmpleado =
    document.getElementById(
        "idEmpleadoSolidarista"
    ).value;


const nombreBanco =
    document.getElementById(
        "nombreBancoSolidarista"
    ).value;


const salario =
    numero(
        document.getElementById(
            "salarioBaseSolidarista"
        ).value
    );


const ahorro =
    numero(
        document.getElementById(
            "ahorroSolidarista"
        ).value
    );


const descuento =
    Math.max(
        salario - ahorro,
        0
    );


if (!idEmpleado) {

    alert(
        "Debe seleccionar un empleado."
    );

    return;

}


if (!nombreBanco) {

    alert(
        "Debe seleccionar un banco."
    );

    return;

}


if (ahorro > salario) {

    alert(
        "El ahorro no puede ser mayor que el salario base."
    );

    return;

}


const payload = {

    IDEMPLEADO:
        Number(idEmpleado),

    NOMBREBANCO:
        nombreBanco,

    AHORRO:
        ahorro,

    FECHA:
        document.getElementById(
            "fechaSolidarista"
        ).value,

    DESCUENTO:
        descuento,

    ESTADO:
        document.getElementById(
            "estadoSolidarista"
        ).value

};


console.log(
    "PAYLOAD GUARDAR:",
    payload
);


try {

    bloquearBoton(
        "btnGuardarSolidarista",
        true,
        "Guardando..."
    );


    const respuesta =
        await fetchJSON(
            API_SOLIDARISTA.guardar,
            {
                method: "POST",

                headers: {
                    "Content-Type":
                        "application/json"
                },

                body:
                    JSON.stringify(
                        payload
                    )
            }
        );


    if (
        respuesta.ok === false
    ) {

        throw new Error(
            respuesta.mensaje ||
            respuesta.message ||
            "No se pudo guardar."
        );

    }


    alert(
        respuesta.mensaje ||
        "Ahorro solidarista guardado correctamente."
    );


    if (modalNuevoSolidarista) {

        modalNuevoSolidarista.hide();

    }


    limpiarFormularioNuevo();


    await cargarRegistrosSolidarista();


} catch (error) {

    console.error(
        "Error guardando:",
        error
    );


    alert(
        "Error al guardar:\n" +
        error.message
    );


} finally {

    bloquearBoton(
        "btnGuardarSolidarista",
        false,
        "Guardar ahorro"
    );

}

}

/* ============================================================
ACTUALIZAR AHORRO
============================================================ */

async function actualizarSolidarista(
evento
) {


evento.preventDefault();


const idBancos =
    document.getElementById(
        "editarIdBancosSolidarista"
    )?.value;


const nombreBanco =
    document.getElementById(
        "editarNombreBancoSolidarista"
    )?.value;


const salario =
    numero(
        document.getElementById(
            "editarSalarioBaseSolidarista"
        )?.value
    );


const ahorro =
    numero(
        document.getElementById(
            "editarAhorroSolidarista"
        )?.value
    );


const descuento =
    Math.max(
        salario - ahorro,
        0
    );


const fecha =
    document.getElementById(
        "editarFechaSolidarista"
    )?.value;


const estado =
    document.getElementById(
        "editarEstadoSolidarista"
    )?.value || "A";


if (!idBancos) {

    alert(
        "No se encontró el ID del registro."
    );

    return;

}


if (!nombreBanco) {

    alert(
        "Debe seleccionar un banco."
    );

    return;

}


if (ahorro > salario) {

    alert(
        "El ahorro no puede ser mayor que el salario base."
    );

    return;

}


if (!fecha) {

    alert(
        "La fecha es obligatoria."
    );

    return;

}


const payload = {

    IDBANCOS:
        Number(idBancos),

    NOMBREBANCO:
        nombreBanco,

    AHORRO:
        ahorro,

    DESCUENTO:
        descuento,

    ESTADO:
        estado,

    FECHA:
        fecha

};


console.log(
    "PAYLOAD ACTUALIZAR:",
    payload
);


try {

    bloquearBoton(
        "btnActualizarSolidarista",
        true,
        "Actualizando..."
    );


    const respuesta =
        await fetchJSON(
            API_SOLIDARISTA.actualizar,
            {
                method: "PUT",

                headers: {
                    "Content-Type":
                        "application/json"
                },

                body:
                    JSON.stringify(
                        payload
                    )
            }
        );


    if (
        respuesta.ok === false
    ) {

        throw new Error(
            respuesta.mensaje ||
            respuesta.message ||
            "No se pudo actualizar el ahorro."
        );

    }


    alert(
        respuesta.mensaje ||
        "Ahorro solidarista actualizado correctamente."
    );


    if (modalEditarSolidarista) {

        modalEditarSolidarista.hide();

    }


    await cargarRegistrosSolidarista();


} catch (error) {

    console.error(
        "Error actualizando Asociación Solidarista:",
        error
    );


    alert(
        "Error al actualizar:\n" +
        error.message
    );


} finally {

    bloquearBoton(
        "btnActualizarSolidarista",
        false,
        "Actualizar ahorro"
    );

}


}

/* ============================================================
ELIMINAR
============================================================ */

async function eliminarSolidarista(
id
) {


// ========================================================
// VALIDAR ID
// ========================================================

if (!id) {

    alert(
        "No se encontró el ID del registro."
    );

    return;

}


// ========================================================
// CONFIRMAR ELIMINACIÓN
// ========================================================

const confirmar =
    confirm(
        "¿Está seguro de eliminar este registro de Asociación Solidarista?"
    );


if (!confirmar) {

    return;

}


// ========================================================
// PREPARAR PAYLOAD
//
// SP_BANCOS_D RECIBE:
//
// @IDBANCOS INT
// ========================================================

const payload = {

    IDBANCOS:
        Number(id)

};


console.log(
    "========================================"
);

console.log(
    "ELIMINANDO ASOCIACIÓN SOLIDARISTA"
);

console.log(
    "URL:",
    API_SOLIDARISTA.eliminar
);

console.log(
    "MÉTODO: POST"
);

console.log(
    "IDBANCOS:",
    payload.IDBANCOS
);

console.log(
    "PAYLOAD ELIMINAR:",
    payload
);

console.log(
    "========================================"
);


try {

    // ====================================================
    // LLAMAR AL BACKEND
    // ====================================================

    const respuesta =
        await fetchJSON(
            API_SOLIDARISTA.eliminar,
            {
                method: "POST",

                headers: {
                    "Content-Type":
                        "application/json"
                },

                body:
                    JSON.stringify(
                        payload
                    )
            }
        );


    // ====================================================
    // VALIDAR RESPUESTA
    // ====================================================

    if (
        respuesta.ok === false
    ) {

        throw new Error(
            respuesta.mensaje ||
            respuesta.message ||
            "No se pudo eliminar el registro."
        );

    }


    // ====================================================
    // MOSTRAR MENSAJE
    // ====================================================

    alert(
        respuesta.mensaje ||
        "Registro eliminado correctamente."
    );


    // ====================================================
    // RECARGAR TABLA
    // ====================================================

    await cargarRegistrosSolidarista();


} catch (error) {

    console.error(
        "Error eliminando Asociación Solidarista:",
        error
    );


    alert(
        "Error al eliminar:\n" +
        error.message
    );

}


}

/* ============================================================
LIMPIAR FORMULARIO NUEVO
============================================================ */

function limpiarFormularioNuevo() {


const formulario =
    document.getElementById(
        "formSolidarista"
    );


if (formulario) {

    formulario.reset();

}


const campos = [

    "idBancosSolidarista",

    "mostrarIdEmpleadoSolidarista",

    "nombreEmpleadoSolidarista",

    "dpiEmpleadoSolidarista",

    "puestoEmpleadoSolidarista",

    "direccionEmpleadoSolidarista",

    "salarioBaseSolidarista",

    "ahorroSolidarista",

    "descuentoSolidarista"

];


campos.forEach(
    id => {

        establecerValor(
            id,
            ""
        );

    }
);


establecerValor(
    "estadoSolidarista",
    "A"
);


const select =
    document.getElementById(
        "idEmpleadoSolidarista"
    );


if (select) {

    select.innerHTML = `
        <option value="">
            Seleccione un empleado
        </option>
    `;

}


}

/* ============================================================
LIMPIAR DATOS EMPLEADO
============================================================ */

function limpiarDatosEmpleadoNuevo() {


const campos = [

    "mostrarIdEmpleadoSolidarista",

    "nombreEmpleadoSolidarista",

    "dpiEmpleadoSolidarista",

    "puestoEmpleadoSolidarista",

    "direccionEmpleadoSolidarista",

    "salarioBaseSolidarista",

    "ahorroSolidarista",

    "descuentoSolidarista"

];


campos.forEach(
    id => {

        establecerValor(
            id,
            ""
        );

    }
);


}

/* ============================================================
FECHA ACTUAL
============================================================ */

function establecerFechaActual() {


const input =
    document.getElementById(
        "fechaSolidarista"
    );


if (!input) {

    return;

}


const ahora =
    new Date();


const year =
    ahora.getFullYear();


const month =
    String(
        ahora.getMonth() + 1
    ).padStart(
        2,
        "0"
    );


const day =
    String(
        ahora.getDate()
    ).padStart(
        2,
        "0"
    );


input.value =
    `${year}-${month}-${day}`;


}

/* ============================================================
FILTRAR TABLA
============================================================ */

function filtrarTablaSolidarista() {


const texto =
    document.getElementById(
        "buscarSolidarista"
    )?.value
        .toLowerCase()
        .trim();


if (!texto) {

    renderizarTablaSolidarista(
        registrosSolidarista
    );

    return;

}


const filtrados =
    registrosSolidarista.filter(
        registro => {

            const contenido = [

                obtenerValor(
                    registro,
                    ["IDEMPLEADO"]
                ),

                obtenerValor(
                    registro,
                    ["NOMBREEMPLEADO"]
                ),

                obtenerValor(
                    registro,
                    ["DPI"]
                ),

                obtenerValor(
                    registro,
                    ["NOMBREPUESTO"]
                ),

                obtenerValor(
                    registro,
                    ["DIRECCION"]
                ),

                obtenerValor(
                    registro,
                    ["NOMBREBANCO"]
                )

            ]
                .map(
                    valor =>
                        String(
                            valor ?? ""
                        ).toLowerCase()
                )
                .join(" ");


            return contenido.includes(
                texto
            );

        }
    );


renderizarTablaSolidarista(
    filtrados
);


}

/* ============================================================
RESUMEN
============================================================ */

function actualizarResumen() {


const activos =
    registrosSolidarista.filter(
        registro =>
            String(
                obtenerValor(
                    registro,
                    ["ESTADO"]
                ) || ""
            ).toUpperCase() === "A"
    );


let totalAhorro = 0;

let totalDescuento = 0;


activos.forEach(
    registro => {

        totalAhorro +=
            numero(
                obtenerValor(
                    registro,
                    [
                        "AHORRO",
                        "INGRESODEDINEROAHORRO"
                    ]
                )
            );


        totalDescuento +=
            numero(
                obtenerValor(
                    registro,
                    ["DESCUENTO"]
                )
            );

    }
);


const totalEmpleados =
    document.getElementById(
        "totalEmpleados"
    );


const totalAhorroElemento =
    document.getElementById(
        "totalAhorro"
    );


const totalDescuentoElemento =
    document.getElementById(
        "totalDescuento"
    );


if (totalEmpleados) {

    totalEmpleados.textContent =
        activos.length;

}


if (totalAhorroElemento) {

    totalAhorroElemento.textContent =
        "Q " +
        formatearNumero(
            totalAhorro
        );

}


if (totalDescuentoElemento) {

    totalDescuentoElemento.textContent =
        "Q " +
        formatearNumero(
            totalDescuento
        );

}


}

/* ============================================================
MOSTRAR CARGANDO
============================================================ */

function mostrarCargandoTabla() {


const tbody =
    document.getElementById(
        "tbodySolidarista"
    );


if (!tbody) {

    return;

}


tbody.innerHTML = `
    <tr>

        <td
            colspan="12"
            class="loading">

            <div
                class="spinner-border text-success me-2">
            </div>

            Cargando registros solidaristas...

        </td>

    </tr>
`;


}

/* ============================================================
FETCH JSON SEGURO
============================================================ */

async function fetchJSON(
url,
opciones = {}
) {

const respuesta =
    await fetch(
        url,
        opciones
    );


const texto =
    await respuesta.text();


let datos;


try {

    datos =
        texto
            ? JSON.parse(texto)
            : {};

} catch (error) {

    console.error(
        "Respuesta no JSON:",
        texto
    );


    throw new Error(
        `El servidor respondió algo que no es JSON. HTTP ${respuesta.status}.`
    );

}


if (!respuesta.ok) {

    throw new Error(
        datos.mensaje ||
        datos.message ||
        `Error HTTP ${respuesta.status}`
    );

}


return datos;


}

/* ============================================================
NORMALIZAR LISTA
============================================================ */

function normalizarLista(
datos
) {


if (Array.isArray(datos)) {

    return datos;

}


if (
    datos &&
    Array.isArray(datos.data)
) {

    return datos.data;

}


if (
    datos &&
    Array.isArray(datos.empleados)
) {

    return datos.empleados;

}


if (
    datos &&
    Array.isArray(datos.registros)
) {

    return datos.registros;

}


if (
    datos &&
    Array.isArray(datos.bancos)
) {

    return datos.bancos;

}


return [];


}

/* ============================================================
OBTENER VALOR
============================================================ */

function obtenerValor(
objeto,
propiedades
) {


if (!objeto) {

    return null;

}


for (
    const propiedad
    of propiedades
) {

    if (
        objeto[propiedad] !==
            undefined &&
        objeto[propiedad] !==
            null
    ) {

        return objeto[propiedad];

    }

}


return null;


}

/* ============================================================
ESTABLECER VALOR DE INPUT
============================================================ */

function establecerValor(
id,
valor
) {


const elemento =
    document.getElementById(id);


if (!elemento) {

    console.warn(
        `No existe el elemento HTML con id="${id}"`
    );

    return;

}


elemento.value =
    valor ?? "";


}

/* ============================================================
CONVERTIR NÚMERO
============================================================ */

function numero(
valor
) {


if (
    valor === null ||
    valor === undefined ||
    valor === ""
) {

    return 0;

}


const convertido =
    Number(
        String(valor)
            .replace(
                /,/g,
                ""
            )
    );


return Number.isFinite(
    convertido
)
    ? convertido
    : 0;


}

/* ============================================================
FORMATEAR NÚMERO
============================================================ */

function formatearNumero(
valor
) {


return numero(valor)
    .toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );


}

/* ============================================================
FORMATEAR FECHA
============================================================ */

function formatearFecha(
fecha
) {


if (!fecha) {

    return "";

}


const texto =
    String(fecha);


if (
    /^\d{4}-\d{2}-\d{2}$/.test(
        texto
    )
) {

    const [
        year,
        month,
        day
    ] =
        texto.split("-");


    return `${day}/${month}/${year}`;

}


const fechaObjeto =
    new Date(fecha);


if (
    Number.isNaN(
        fechaObjeto.getTime()
    )
) {

    return texto;

}


return fechaObjeto.toLocaleDateString(
    "es-GT"
);


}

/* ============================================================
CONVERTIR FECHA PARA INPUT DATE
============================================================ */

function convertirFechaInput(
fecha
) {


if (!fecha) {

    return "";

}


const texto =
    String(fecha)
        .trim();


/* --------------------------------------------------------
   2026-09-21
-------------------------------------------------------- */

if (
    /^\d{4}-\d{2}-\d{2}$/.test(
        texto
    )
) {

    return texto;

}


/* --------------------------------------------------------
   21/09/2026
-------------------------------------------------------- */

if (
    /^\d{2}\/\d{2}\/\d{4}$/.test(
        texto
    )
) {

    const [
        dia,
        mes,
        anio
    ] =
        texto.split("/");


    return `${anio}-${mes}-${dia}`;

}


const fechaObjeto =
    new Date(fecha);


if (
    Number.isNaN(
        fechaObjeto.getTime()
    )
) {

    return "";

}


const year =
    fechaObjeto.getFullYear();


const month =
    String(
        fechaObjeto.getMonth() + 1
    ).padStart(
        2,
        "0"
    );


const day =
    String(
        fechaObjeto.getDate()
    ).padStart(
        2,
        "0"
    );


return `${year}-${month}-${day}`;


}

/* ============================================================
ESCAPAR HTML
============================================================ */

function escaparHTML(
valor
) {


return String(
    valor ?? ""
)
    .replace(
        /&/g,
        "&amp;"
    )
    .replace(
        /</g,
        "&lt;"
    )
    .replace(
        />/g,
        "&gt;"
    )
    .replace(
        /"/g,
        "&quot;"
    )
    .replace(
        /'/g,
        "&#039;"
    );


}

/* ============================================================
BLOQUEAR BOTÓN
============================================================ */

function bloquearBoton(
id,
bloquear,
texto
) {


const boton =
    document.getElementById(id);


if (!boton) {

    return;

}


boton.disabled =
    bloquear;


if (bloquear) {

    boton.dataset.textoOriginal =
        boton.innerHTML;


    boton.innerHTML = `
        <span
            class="spinner-border spinner-border-sm me-1">
        </span>

        ${texto}
    `;

} else {

    boton.innerHTML =
        boton.dataset.textoOriginal ||
        texto;

}


}
